import styled from 'styled-components';
import ClockIcon from '/public/images/clock.svg';
import CutleryIcon from '/public/images/cutlery.svg';
import GroupIcon from '/public/images/group.svg';
import LibraryIcon from '/public/images/library.svg';
import SmileIcon from '/public/images/smile.svg';
import WorldIcon from '/public/images/world.svg';
import Image from 'next/image';
import {getColor} from '@/styles/ThemeConfig';
import {breakpoints} from "@/styles/sizes";
import LocationMaincolorIcon from '/public/images/location-maincolor.svg';
import CocktailBrownIcon from '/public/images/cocktail_brown.svg';

// Styled Components
const SectionContainer = styled.div`
  background-color: ${getColor('grayBackground')};
  padding: 30px 0;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 7fr 5fr;
    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 30px;

    @media only screen and (${breakpoints.mobile}) {
        padding: 0 20px;
        row-gap: 20px;
    }
`;

const InfoItem = styled.div`
    color: ${getColor('greenText')};
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
`;

// Main Component
export default function TourInfoSection({ duration, location, numOfStops, numOfPeople, type, funFact,language,wineTastings }) {
    return (
            (
            duration ||
            wineTastings ||
            location ||
            !!parseInt(numOfStops) ||
            !!parseInt(numOfPeople) ||
            language ||
            type ||
            funFact
            )
            &&
        <SectionContainer>
            <div className="container_small">
                <ContentContainer>
                    <InfoWrapper>

                        {
                            duration && <InfoItem>
                                <Image src={ClockIcon} alt="ClockIcon" width={20} height={20} /> {duration}
                            </InfoItem>
                        }
                        {
                            wineTastings && <InfoItem>
                                <Image src={CocktailBrownIcon} alt="CocktailBrownIcon" width={20} height={20} /> {wineTastings}
                            </InfoItem>

                        }
                        {
                            location &&   <InfoItem>
                                <Image src={LocationMaincolorIcon} alt="LocationMaincolorIcon" width={20} height={20} /> {location}
                            </InfoItem>
                        }
                        {
                            !!parseInt(numOfStops) &&  <InfoItem>
                                <Image src={CutleryIcon} alt="CutleryIcon" width={20} height={20} /> {numOfStops}
                            </InfoItem>
                        }
                        {
                            !!parseInt(numOfPeople) && <InfoItem>
                                <Image src={GroupIcon} alt="GroupIcon" width={20} height={20} /> {numOfPeople}
                            </InfoItem>
                        }
                        {
                            language && <InfoItem>
                                <Image src={WorldIcon} alt="WorldIcon" width={20} height={20} /> {language}
                            </InfoItem>
                        }
                        {
                            type &&  <InfoItem>
                                <Image src={LibraryIcon} alt="LibraryIcon" width={20} height={20} /> {type}
                            </InfoItem>
                        }
                        {
                            funFact && <InfoItem>
                                <Image src={SmileIcon} alt="SmileIcon" width={20} height={20} /> {funFact}
                            </InfoItem>
                        }
                    </InfoWrapper>
                </ContentContainer>
            </div>
        </SectionContainer>
    );
}
